import { createReducer, on } from '@ngrx/store';
import {loadUserSucceeded, loadUserStart, loadUserFailed} from '../actions/getUser.actions';
import { UserItem } from '../../user.model';
import {NodeItem} from '../../../projektverwaltung/node.model';
import {DashboardItem} from '../../dashboard.model';
import {loadDashboardFailed, loadDashboardStart, loadDashboardSucceeded} from '../actions/getDashboard.actions';
import {startTimeDashboardFailed, startTimeDashboardStart, startTimeDashboardSucceeded} from '../actions/dashboard-startTime.actions';
import {stopTimeDashboardFailed, stopTimeDashboardStart, stopTimeDashboardSucceeded} from '../actions/dashboard-stopTime.actions';
import {addDashboardFailed, addDashboardStart, addDashboardSucceeded} from '../actions/dashboard-add.actions';
import {ProjektItem} from '../../../projektverwaltung/projekt.model';
import {checkDashboardFailed, checkDashboardStart, checkDashboardSucceeded} from "../actions/dashboard-check.actions";
import {MenuItem} from '../../../../ui-components/nav-bar/nav-bar.component';
import {
  pauseTimeDashboardFailed,
  pauseTimeDashboardStart,
  pauseTimeDashboardSucceeded
} from '@src/app/pages/landingpage/store/actions/dashboard-pauseTime.actions';
import {
  continueTimeDashboardFailed,
  continueTimeDashboardStart,
  continueTimeDashboardSucceeded
} from '@src/app/pages/landingpage/store/actions/dashboard-continueTime.actions';

export interface State {
    isLoading: boolean;
    items: UserItem;
    menu: MenuItem[];
  dashboards: {
    items: DashboardItem[];
  };
  projektstufen: {
    items: ProjektItem[];
  };
}

export const initialState: State = {
    isLoading: false,
    // Vorlage für den eingeloggten User
  // tslint:disable-next-line:max-line-length
    items: {id: null, email: null, firmaId: null, rolleId: null, vorname: null, name: null, anrede: null, geburtstag: null, passwort: null, mobile: null, rolle: null, ferientage: null, anstellungprozent: null, ort: null, plz: null, str1: null, str2: null, session: null},
  menu: [],
  dashboards: {
    items: [],
  },
  projektstufen: {
    items: [],
  },
};

const ons = [
    on(loadUserStart, (state: State) => ({ ...state, isLoading: true })),
    on(loadUserSucceeded, (state: State, action) => ({
        ...state,
        isLoading: false,
        items: action.item,
    })),

  on(loadUserFailed, (state: State) => ({ ...state, isLoading: false })),

  on(loadDashboardStart, (state: State) => ({ ...state, isLoading: true })),
  on(loadDashboardFailed, (state: State) => ({ ...state, isLoading: false })),
  on(loadDashboardSucceeded, (state: State, action) => ({
    ...state,
    isLoading: false,
    dashboards: {
      ...state.dashboards,
      items: action.dashboard,
    },
  })),
  on(startTimeDashboardStart, (state: State) => ({ ...state, isLoading: true })),
  on(startTimeDashboardSucceeded, (state: State) => ({ ...state, isLoading: false })),
  on(startTimeDashboardFailed, (state: State) => ({ ...state, isLoading: false })),
  on(continueTimeDashboardStart, (state: State) => ({ ...state, isLoading: true })),
  on(continueTimeDashboardSucceeded, (state: State) => ({ ...state, isLoading: false })),
  on(continueTimeDashboardFailed, (state: State) => ({ ...state, isLoading: false })),
  on(pauseTimeDashboardStart, (state: State) => ({ ...state, isLoading: true })),
  on(pauseTimeDashboardSucceeded, (state: State) => ({ ...state, isLoading: false })),
  on(pauseTimeDashboardFailed, (state: State) => ({ ...state, isLoading: false })),
  on(stopTimeDashboardStart, (state: State) => ({ ...state, isLoading: true })),
  on(stopTimeDashboardSucceeded, (state: State) => ({ ...state, isLoading: false })),
  on(stopTimeDashboardFailed, (state: State) => ({ ...state, isLoading: false })),
  on(addDashboardStart, (state: State) => ({ ...state, isAddingFirma: true })),
  on(addDashboardFailed, (state: State) => ({ ...state, isAddingFirma: false })),
  on(addDashboardSucceeded, (state: State) => ({ ...state, isAddingFirma: false })),
  on(checkDashboardStart, (state: State) => ({ ...state, isAddingFirma: true })),
  on(checkDashboardSucceeded, (state: State) => ({ ...state, isAddingFirma: false })),
  on(checkDashboardFailed, (state: State) => ({ ...state, isAddingFirma: false })),
];

export const landingpageReducer = createReducer(initialState, ...ons);
